var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Add",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Base",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "settings",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3180",
    "data-name": "Path 3180",
    d: "M8.5,16h-1a1.475,1.475,0,0,1-1.473-1.473v-.34a6.459,6.459,0,0,1-1-.416l-.241.241a1.473,1.473,0,0,1-2.083,0l-.71-.71a1.473,1.473,0,0,1,0-2.083l.241-.241a6.46,6.46,0,0,1-.416-1h-.34A1.475,1.475,0,0,1,0,8.5v-1A1.475,1.475,0,0,1,1.473,6.025h.34a6.461,6.461,0,0,1,.416-1l-.241-.241a1.473,1.473,0,0,1,0-2.083l.71-.71a1.473,1.473,0,0,1,2.083,0l.241.241a6.465,6.465,0,0,1,1-.416v-.34A1.475,1.475,0,0,1,7.5,0h1A1.475,1.475,0,0,1,9.975,1.473v.34a6.459,6.459,0,0,1,1,.416l.241-.241a1.473,1.473,0,0,1,2.083,0l.71.71a1.473,1.473,0,0,1,0,2.083l-.241.241a6.46,6.46,0,0,1,.416,1h.34A1.475,1.475,0,0,1,16,7.5v1a1.475,1.475,0,0,1-1.473,1.473h-.34a6.461,6.461,0,0,1-.416,1l.241.241a1.473,1.473,0,0,1,0,2.083l-.71.71a1.473,1.473,0,0,1-2.083,0l-.241-.241a6.465,6.465,0,0,1-1,.416v.34A1.475,1.475,0,0,1,8.5,16ZM5.179,12.787a5.525,5.525,0,0,0,1.432.595.469.469,0,0,1,.352.454v.692a.536.536,0,0,0,.535.535h1a.536.536,0,0,0,.535-.535v-.692a.469.469,0,0,1,.352-.454,5.525,5.525,0,0,0,1.432-.595.469.469,0,0,1,.57.072l.49.49a.535.535,0,0,0,.757,0l.71-.71a.535.535,0,0,0,0-.757l-.49-.49a.469.469,0,0,1-.072-.57,5.524,5.524,0,0,0,.594-1.432.469.469,0,0,1,.454-.352h.692a.536.536,0,0,0,.535-.535v-1a.536.536,0,0,0-.535-.535h-.692a.469.469,0,0,1-.454-.352,5.526,5.526,0,0,0-.594-1.432.469.469,0,0,1,.072-.57l.49-.49a.535.535,0,0,0,0-.757l-.71-.71a.535.535,0,0,0-.757,0l-.49.49a.469.469,0,0,1-.57.072,5.525,5.525,0,0,0-1.432-.595.469.469,0,0,1-.352-.454V1.473A.536.536,0,0,0,8.5.938h-1a.536.536,0,0,0-.535.535v.692a.469.469,0,0,1-.352.454,5.525,5.525,0,0,0-1.432.595.469.469,0,0,1-.57-.072l-.49-.49a.535.535,0,0,0-.757,0l-.71.71a.535.535,0,0,0,0,.757l.49.49a.469.469,0,0,1,.072.57,5.524,5.524,0,0,0-.595,1.432.469.469,0,0,1-.454.352H1.473A.536.536,0,0,0,.938,7.5v1a.536.536,0,0,0,.535.535h.692a.469.469,0,0,1,.454.352,5.525,5.525,0,0,0,.595,1.432.469.469,0,0,1-.072.57l-.49.49a.535.535,0,0,0,0,.757l.71.71a.535.535,0,0,0,.757,0l.49-.49a.471.471,0,0,1,.57-.072Z",
    fill: "#b947ae",
    stroke: "#b947ae",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3181",
    "data-name": "Path 3181",
    d: "M147.2,149.795a2.6,2.6,0,1,1,2.6-2.6A2.6,2.6,0,0,1,147.2,149.795Zm0-4.5a1.9,1.9,0,1,0,1.9,1.9A1.9,1.9,0,0,0,147.2,145.3Z",
    transform: "translate(-139.197 -139.197)",
    fill: "#b947ae",
    stroke: "#b947ae",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.28806175c987b65216da5d997082579e.svg";
export { ForwardRef as ReactComponent };